module.exports = __webpack_public_path__ + "img/法老王.9d76135e.png";